import React from 'react';
import { Container, CssBaseline, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import HeaderBar, { DistributionHeaderBar } from '../../header/HeaderBar';
import SideHeader, { DistributionSideHeader } from '../../header/SideHeader';

const useStyles = makeStyles((theme) => ({
  background: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    background: '#fff',
  },
  sideHeaderWrapper: {
    height: '100%',
    overflowY: 'auto',
  },
  contentWrapper: {
    width: '100%',
    height: '100%',
    flex: '1',
    overflowY: 'auto',
  },
  container: {
    width: '100%',
    height: 'calc(100vh - 12vh)',
    [theme.breakpoints.up('md')]: {
      marginTop: '0px',
      height: '100%',
    },
  },
}));

interface LayoutProps {
  isDistribution?: boolean;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  isDistribution,
  children,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));
  if (!children) {
    return null;
  }
  return (
    <>
      <CssBaseline />
      {isTablet ? (
        <div className={classes.background}>
          <div className={classes.sideHeaderWrapper}>
            {isDistribution ? <DistributionSideHeader /> : <SideHeader />}
          </div>
          <div
            className={classes.contentWrapper}
          >
            <Container
              component="main"
              className={classes.container}
              disableGutters
            >
              {children}
            </Container>
          </div>
        </div>
      ) : (
        <>
          {isDistribution ? <DistributionHeaderBar /> : <HeaderBar />}

          <Container
            component="main"
            className={classes.container}
            disableGutters={true}
          >
            {children}
          </Container>
        </>
      )}
    </>
  );
};

export default Layout;
